// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #0A0A1B !important;
  background-color: #0A0A1B !important;
  color: white;
  min-height: 100vh;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Стилизация скроллбара для WebKit браузеров (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #0A0A1B;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Для Firefox */
html {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) #0A0A1B;
  background: #0A0A1B !important;
  color-scheme: dark;
  -webkit-color-scheme: dark;
}

/* Safari-specific fixes with alternate colors */
@supports (-webkit-appearance: none) {
  html {
    background: #0B0B1A !important;
    background-color: #0B0B1A !important;
    -webkit-color-scheme: dark !important;
  }
  
  body {
    background: #0B0B1A !important;
    background-color: #0B0B1A !important;
  }
  
  #root {
    background: #0B0B1A !important;
    background-color: #0B0B1A !important;
    min-height: 100vh;
  }
}

/* Extra aggressive Safari fix with gray-tinted dark */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  html, body, #root {
    background: #0C0C18 !important;
    background-color: #0C0C18 !important;
  }
}

/* Alternative for very problematic Safari versions */
@media screen and (-webkit-min-device-pixel-ratio: 1) {
  _::-webkit-full-page-media, _:future, :root html, :root body, :root #root {
    background: #111111 !important;
    background-color: #111111 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;EAC9B,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;aACW;AACb;;AAEA,sEAAsE;AACtE;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,iDAAiD;EACjD,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,gDAAgD;AAChD;EACE;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,qCAAqC;EACvC;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;IAC9B,oCAAoC;IACpC,iBAAiB;EACnB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #0A0A1B !important;\n  background-color: #0A0A1B !important;\n  color: white;\n  min-height: 100vh;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Стилизация скроллбара для WebKit браузеров (Chrome, Safari, Edge) */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #0A0A1B;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* Для Firefox */\nhtml {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) #0A0A1B;\n  background: #0A0A1B !important;\n  color-scheme: dark;\n  -webkit-color-scheme: dark;\n}\n\n/* Safari-specific fixes with alternate colors */\n@supports (-webkit-appearance: none) {\n  html {\n    background: #0B0B1A !important;\n    background-color: #0B0B1A !important;\n    -webkit-color-scheme: dark !important;\n  }\n  \n  body {\n    background: #0B0B1A !important;\n    background-color: #0B0B1A !important;\n  }\n  \n  #root {\n    background: #0B0B1A !important;\n    background-color: #0B0B1A !important;\n    min-height: 100vh;\n  }\n}\n\n/* Extra aggressive Safari fix with gray-tinted dark */\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  html, body, #root {\n    background: #0C0C18 !important;\n    background-color: #0C0C18 !important;\n  }\n}\n\n/* Alternative for very problematic Safari versions */\n@media screen and (-webkit-min-device-pixel-ratio: 1) {\n  _::-webkit-full-page-media, _:future, :root html, :root body, :root #root {\n    background: #111111 !important;\n    background-color: #111111 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
